import React, { ReactElement } from 'react';

export const SaladIcon = (): ReactElement => {
  return (
    <svg
      width="49px"
      height="49px"
      viewBox="0 0 83 82"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Salad</title>
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="Salad" transform="translate(2.000000, 2.000000)">
          <path
            d="M29.0272,73.0767 L25.4481,73.0767 C11.6454,73.0767 0.45605,61.8873 0.45605,48.0847 C0.45605,47.9592 0.55778,47.8575 0.68325,47.8575 L11,47.8575 M39.881,73.0767 L52.0793,73.0767 C56.9686,73.0767 61.5299,71.6727 65.3822,69.2459 M68.931,66.5408 C70.2945,65.2952 71.5194,63.9005 72.5801,62.3824 C75.4108,58.3312 77.0713,53.4018 77.0713,48.0847 C77.0713,47.9592 76.9696,47.8575 76.8441,47.8575 L46.5,47.8575"
            id="Shape"
            stroke="#90A4C5"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
          <line
            x1="66.6904"
            y1="78.5038"
            x2="52.6904"
            y2="78.5038"
            id="Path"
            stroke="#90A4C5"
            strokeWidth="2.5"
            strokeLinecap="round"
          ></line>
          <line
            x1="72.6904"
            y1="78.5038"
            x2="70.4558"
            y2="78.5038"
            id="Path"
            stroke="#90A4C5"
            strokeWidth="2.5"
            strokeLinecap="round"
          ></line>
          <path
            d="M7.3525,52.3612 C7.3525,57.2486 11.08,61.6537 16.0981,64.5342 M18.6519,65.8202 C19.5481,66.2127 20.469,66.5581 21.4034,66.8516"
            id="Shape"
            stroke="#90A4C5"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
          <path
            d="M56.6406,73.0766 L56.6406,75.9497 C56.6406,77.3602 55.4972,78.5035 54.0868,78.5035 L22.8022,78.5035 C21.3918,78.5035 20.2484,77.3602 20.2484,75.9497 L20.2484,73.0766"
            id="Path"
            stroke="#90A4C5"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
          <path
            d="M58.1776,5.7296 C54.0961,4.1079 49.3357,5.681 47.0748,9.597 C45.4172,12.4681 45.523,15.8711 47.0515,18.5548 C46.8473,18.8219 46.6582,19.1048 46.486,19.403 C44.4738,22.8883 45.4418,27.2764 48.5992,29.6165 L46.655,32.9839 C44.8412,36.1255 45.9176,40.1425 49.0591,41.9563 C52.2006,43.77 56.2177,42.6937 58.0314,39.5521 L59.9642,36.2046 C63.612,37.9172 68.026,36.5775 70.0777,33.0237 C70.2499,32.7255 70.4004,32.4203 70.5296,32.11 C73.618,32.0918 76.618,30.482 78.2757,27.6109 C80.5367,23.6947 79.5187,18.7854 76.0733,16.0616 C78.2452,11.2572 76.4602,5.4951 71.7976,2.8032 C67.135,0.1112 61.2524,1.4464 58.1776,5.7296 Z"
            id="Path"
            stroke="#90A4C5"
            strokeWidth="2.5"
          ></path>
          <path
            d="M66.117,12.1805 L55.455,30.6477 M53.6967,33.503 L52.1006,36.2677 M62.2953,18.8236 C63.4127,16.8882 66.0752,16.3212 68.0106,17.4386 C68.8921,17.9475 69.5096,18.738 69.8153,19.6309 M62.1562,18.8506 C63.2736,16.9152 62.5061,14.2606 60.5708,13.1432 C59.6892,12.6343 58.6958,12.4947 57.7698,12.6765 M58.6443,25.3546 C59.7617,23.4192 62.2364,22.7561 64.1718,23.8735 C65.0533,24.3824 65.6709,25.1729 65.9765,26.0658 M58.444,25.239 C59.5614,23.3036 58.8983,20.8289 56.9629,19.7115 C56.0814,19.2025 55.088,19.0629 54.1619,19.2447"
            id="Shape"
            stroke="#90A4C5"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
          <path
            d="M13.2052,31.5573 L14.2788,32.1975 L14.7191,31.4593 L14.1873,30.784 L13.2052,31.5573 Z M18.3144,42.2964 L19.5617,42.2138 L19.494,41.1905 L18.4771,41.057 L18.3144,42.2964 Z M26.7619,47.4044 L27.8379,46.7681 L27.3062,45.8692 L26.3271,46.2325 L26.7619,47.4044 Z M29.2396,51.5939 L30.3155,50.9576 L29.2396,51.5939 Z M38.33,46.2178 L39.4059,45.5815 L38.33,46.2178 Z M35.844,42.0143 L35.0143,41.0793 L34.2434,41.7634 L34.7681,42.6506 L35.844,42.0143 Z M37.261,34.1646 L36.1851,34.8009 L37.261,34.1646 Z M35.6826,32.423 L34.556,31.8813 L34.1059,32.8175 L34.9438,33.4314 L35.6826,32.423 Z M35.4689,25.6788 L36.5448,25.0424 L35.4689,25.6788 Z M28.6318,22.2548 L27.4906,22.7649 L27.8503,23.5695 L28.729,23.501 L28.6318,22.2548 Z M28.2067,21.433 L27.1308,22.0693 L28.2067,21.433 Z M16.0533,18.6982 L16.6896,19.7742 L16.0533,18.6982 Z M30.2617,45.8154 C30.6131,46.4096 31.3797,46.6064 31.9739,46.255 C32.5681,45.9035 32.765,45.137 32.4135,44.5427 L30.2617,45.8154 Z M25.0903,32.16 C24.7389,31.5658 23.9723,31.369 23.3781,31.7204 C22.7839,32.0718 22.5871,32.8384 22.9385,33.4326 L25.0903,32.16 Z M21.038,30.2189 C21.3894,30.8131 22.156,31.0099 22.7502,30.6585 C23.3444,30.3071 23.5413,29.5405 23.1898,28.9463 L21.038,30.2189 Z M21.5183,26.12 C21.1669,25.5258 20.4003,25.3289 19.8061,25.6804 C19.2119,26.0318 19.0151,26.7984 19.3665,27.3926 L21.5183,26.12 Z M14.1873,30.784 C14.0011,30.5475 13.8284,30.296 13.6708,30.0295 L11.519,31.3022 C11.7332,31.6643 11.9686,32.0073 12.2231,32.3306 L14.1873,30.784 Z M14.1657,38.2778 C13.0566,36.4025 13.1491,34.092 14.2788,32.1975 L12.1316,30.9171 C10.5803,33.5186 10.3939,36.8112 12.0138,39.5504 L14.1657,38.2778 Z M18.4771,41.057 C16.6889,40.8223 15.0939,39.8472 14.1657,38.2778 L12.0138,39.5504 C13.366,41.8368 15.668,43.2097 18.1518,43.5357 L18.4771,41.057 Z M20.1931,44.2587 C19.8141,43.6179 19.6085,42.9211 19.5617,42.2138 L17.0672,42.3789 C17.139,43.4639 17.4562,44.5421 18.0412,45.5313 L20.1931,44.2587 Z M26.3271,46.2325 C23.9551,47.1126 21.3824,46.2697 20.1931,44.2587 L18.0412,45.5313 C19.9101,48.6913 23.8131,49.8318 27.1967,48.5764 L26.3271,46.2325 Z M25.686,48.0408 L28.1637,52.2302 L30.3155,50.9576 L27.8379,46.7681 L25.686,48.0408 Z M28.1637,52.2302 C29.9486,55.2483 33.9099,56.0617 36.9526,54.2622 L35.68,52.1103 C33.7022,53.28 31.3267,52.6675 30.3155,50.9576 L28.1637,52.2302 Z M36.9526,54.2622 C39.9953,52.4627 41.1909,48.5996 39.4059,45.5815 L37.2541,46.8541 C38.2653,48.564 37.6577,50.9407 35.68,52.1103 L36.9526,54.2622 Z M39.4059,45.5815 L36.9199,41.378 L34.7681,42.6506 L37.2541,46.8541 L39.4059,45.5815 Z M36.1851,34.8009 C37.363,36.7927 36.8833,39.4208 35.0143,41.0793 L36.6737,42.9493 C39.3415,40.5819 40.1876,36.6576 38.3369,33.5283 L36.1851,34.8009 Z M34.9438,33.4314 C35.4352,33.7914 35.859,34.2496 36.1851,34.8009 L38.3369,33.5283 C37.8343,32.6784 37.1783,31.9693 36.4213,31.4147 L34.9438,33.4314 Z M34.393,26.3151 C35.4042,28.0249 35.4164,30.0922 34.556,31.8813 L36.8091,32.9648 C37.9974,30.4935 38.0198,27.5365 36.5448,25.0424 L34.393,26.3151 Z M28.729,23.501 C31.036,23.321 33.2371,24.3606 34.393,26.3151 L36.5448,25.0424 C34.8555,22.1859 31.6945,20.762 28.5345,21.0085 L28.729,23.501 Z M27.1308,22.0693 C27.2654,22.297 27.3853,22.5292 27.4906,22.7649 L29.7729,21.7446 C29.629,21.4227 29.4657,21.1062 29.2826,20.7967 L27.1308,22.0693 Z M16.6896,19.7742 C20.4682,17.5395 25.1165,18.6635 27.1308,22.0693 L29.2826,20.7967 C26.4947,16.0826 20.2605,14.7578 15.417,17.6223 L16.6896,19.7742 Z M13.6708,30.0295 C11.6566,26.6237 12.911,22.0088 16.6896,19.7742 L15.417,17.6223 C10.5734,20.4868 8.7311,26.5881 11.519,31.3022 L13.6708,30.0295 Z M32.4135,44.5427 L25.0903,32.16 L22.9385,33.4326 L30.2617,45.8154 L32.4135,44.5427 Z M23.1898,28.9463 L21.5183,26.12 L19.3665,27.3926 L21.038,30.2189 L23.1898,28.9463 Z"
            id="Shape"
            fill="#90A4C5"
            fillRule="nonzero"
          ></path>
          <line
            x1="25"
            y1="0"
            x2="32"
            y2="11.5"
            id="Path"
            stroke="#90A4C5"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></line>
          <line
            x1="34.5171"
            y1="0"
            x2="36.1268"
            y2="9.2862"
            id="Path"
            stroke="#90A4C5"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></line>
          <path
            d="M0.05182,26.1484 C0.05182,26.1484 -0.43148,17.0999 6.672,10.873 M14.0777,6.7347 C12.7562,7.1747 11.5588,7.6909 10.474,8.2663"
            id="Shape"
            stroke="#90A4C5"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
          <path
            d="M48.8622,63.2972 C46.4312,60.8662 46.4312,56.9248 48.8622,54.4938 C51.2932,52.0628 55.2346,52.0628 57.6656,54.4938 C60.0967,56.9248 60.0967,60.8662 57.6656,63.2972"
            id="Path"
            stroke="#90A4C5"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
          <path
            d="M44.8291,63.4997 L24.3827,63.4997 C24.3827,60.4175 22.1009,57.7206 18.8685,57.7206 C18.8685,54.831 16.5868,52.3267 13.5445,52.3267"
            id="Path"
            stroke="#90A4C5"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
          <path
            d="M57.5982,63.3401 C63.0268,63.3401 67.9707,58.4245 69.6436,52.0074"
            id="Path"
            stroke="#90A4C5"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
        </g>
      </g>
    </svg>
  );
};
